// ForecastWidget — Dashboard'da pipeline forecast özetini gösterir.
// /api/crm/forecast'tan status bazında count + expected_total + weighted_total alır.
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { fmtAmount } from '../utils/numberFormat';

const STATUS_LABELS = {
  open:        { l: 'Açık',             c: '#64748b' },
  contacted:   { l: 'İletişim Kuruldu', c: '#3b82f6' },
  negotiation: { l: 'Görüşmede',        c: '#f59e0b' },
};

export default function ForecastWidget({ onNavigate }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/crm/forecast')
      .then(r => { if (r.data?.success) setData(r.data.data || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const totalCount = data.reduce((a, b) => a + (b.count || 0), 0);
  const totalExpected = data.reduce((a, b) => a + parseFloat(b.expected_total || 0), 0);
  const totalWeighted = data.reduce((a, b) => a + parseFloat(b.weighted_total || 0), 0);

  if (loading) {
    return <div style={S.wrap}><div style={S.title}>📊 CRM Pipeline Tahmini</div><div style={{ padding: 12, color: 'var(--text-tertiary)', fontSize: 'var(--text-sm)' }}>Yükleniyor...</div></div>;
  }

  if (!totalCount) {
    return (
      <div style={S.wrap}>
        <div style={S.title}>📊 CRM Pipeline Tahmini</div>
        <div style={{ padding: 14, color: 'var(--text-tertiary)', fontSize: 'var(--text-sm)', textAlign: 'center' }}>
          Açık lead yok. CRM Pipeline'a yeni potansiyel ekleyin.
        </div>
      </div>
    );
  }

  return (
    <div style={S.wrap}>
      <div style={S.title}>
        📊 CRM Pipeline Tahmini
        {onNavigate && (
          <button onClick={() => onNavigate('crm-pipeline')} style={S.openBtn}>Aç →</button>
        )}
      </div>

      <div style={S.summary}>
        <div style={S.summaryCell}>
          <div style={S.summaryLabel}>Açık Lead</div>
          <div style={S.summaryValue}>{totalCount}</div>
        </div>
        <div style={S.summaryCell}>
          <div style={S.summaryLabel}>Beklenen Tutar</div>
          <div style={S.summaryValue}>{fmtAmount(totalExpected)} ₺</div>
        </div>
        <div style={{ ...S.summaryCell, borderRight: 'none' }}>
          <div style={S.summaryLabel}>Ağırlıklı (× %)</div>
          <div style={{ ...S.summaryValue, color: 'var(--accent-primary)' }}>{fmtAmount(totalWeighted)} ₺</div>
        </div>
      </div>

      <div style={S.bars}>
        {data.map(d => {
          const lbl = STATUS_LABELS[d.status] || { l: d.status, c: '#94a3b8' };
          const pct = totalExpected > 0 ? (parseFloat(d.expected_total) / totalExpected) * 100 : 0;
          return (
            <div key={d.status} style={S.barRow}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--text-xs)', marginBottom: 2 }}>
                <span style={{ color: lbl.c, fontWeight: 600 }}>● {lbl.l}</span>
                <span style={{ color: 'var(--text-secondary)' }}>
                  {d.count} lead · <strong>{fmtAmount(d.expected_total)} ₺</strong>
                </span>
              </div>
              <div style={{ height: 8, background: 'var(--bg-tertiary)', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ height: '100%', width: pct + '%', background: lbl.c, opacity: 0.7, transition: 'width 0.3s' }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const S = {
  wrap: {
    background: 'var(--bg-card)',
    border: '1px solid var(--border-secondary)',
    borderRadius: 'var(--r-md)',
    padding: 14,
    boxShadow: 'var(--shadow-xs)',
    margin: '14px 0',
  },
  title: {
    fontSize: 'var(--text-md)',
    fontWeight: 700,
    color: 'var(--text-primary)',
    marginBottom: 12,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  openBtn: {
    background: 'transparent',
    border: 'none',
    color: 'var(--accent-primary)',
    fontSize: 'var(--text-xs)',
    fontWeight: 600,
    cursor: 'pointer',
  },
  summary: {
    display: 'flex',
    background: 'var(--bg-tertiary)',
    borderRadius: 'var(--r-md)',
    padding: 10,
    marginBottom: 14,
  },
  summaryCell: {
    flex: 1,
    textAlign: 'center',
    borderRight: '1px solid var(--border-secondary)',
    padding: '0 8px',
  },
  summaryLabel: { fontSize: '0.65rem', color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 700, marginBottom: 4 },
  summaryValue: { fontSize: 'var(--text-lg)', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'JetBrains Mono, monospace' },
  bars: { display: 'flex', flexDirection: 'column', gap: 10 },
  barRow: {},
};
